/* External */
import { memo, useCallback, useState } from 'react';
import PropTypes from 'prop-types';

/* Components */
import KeyButton from './KeyButton';

/* Utils */
import { noOp } from '../../utils/functions';
import withCursorVisibilityFilterFocusable from '../../hocs/withCursorVisibilityFilter.hoc';

/* Styles */
import './CustomKey.scss';

function CustomKey({
  character,
  variation,
  onArrowPress,
  onPress,
  className,
  hasFocusedChild,
  index,
}) {
  const [isFocusedChild, setIsFocusedChild] = useState(false);

  const handleKeyPress = useCallback((key) => {
    onPress(key.character);
  }, [onPress]);

  const onBlurFocusedChild = useCallback(() => {
    setIsFocusedChild(false);
  }, []);

  const onBecameFocusedChild = useCallback(() => {
    setIsFocusedChild(true);
  }, []);

  return (
    <div
      className={`dtv-html5-c-custom-key ${
        hasFocusedChild ? 'dtv-html5-c-custom-key--focused' : ''
      } ${className}`}
    >
      <KeyButton
        onEnterPress={handleKeyPress}
        className={`${isFocusedChild ? 'dtv-html5-c-custom-key__focused-child' : 'dtv-html5-c-custom-key__character'}`}
        character={character}
        onArrowPress={onArrowPress}
        index={index}
      />
      {
        variation && (
          <KeyButton
            onEnterPress={handleKeyPress}
            className="dtv-html5-c-custom-key__variation"
            character={variation}
            onArrowPress={onArrowPress}
            focusable={hasFocusedChild}
            index={index}
            isVariation
            onBecameFocused={onBecameFocusedChild}
            onBecameBlurred={onBlurFocusedChild}
          />
        )
      }
    </div>
  );
}

CustomKey.defaultProps = {
  character: '',
  variation: '',
  onPress: noOp,
  onArrowPress: noOp,
  className: '',
  index: undefined,
};

CustomKey.propTypes = {
  character: PropTypes.string,
  variation: PropTypes.string,
  onPress: PropTypes.func,
  onArrowPress: PropTypes.func,
  className: PropTypes.string,
  hasFocusedChild: PropTypes.bool.isRequired,
  index: PropTypes.number,
};

export default memo(withCursorVisibilityFilterFocusable({ trackChildren: true })(memo(CustomKey)));
